export default __webpack_public_path__ + "static/media/pammContentIcon4.93af1141.webp";